import React from 'react';
import { compose, find, propEq, merge } from 'ramda';
import styleFile from './inputNotify.js';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import format from 'string-template';
import { withForm } from './';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import RichText from '@synergycms_core/components/generic/RichText';

export default compose(
  withForm(),
  PropertyManager(['model', 'validations', 'css', 'form', 'formModel']),
  withThemeJSS({styleFile,link:true}),
  withContent('i18n')
)(
  class InputNotify extends React.Component {
    static displayName = 'InputNotify';
    constructor(props, context) {
      super(props);
    }

    getValidationText = () => {
      const { config, content } = this.props;
      const { form, formModel } = config;
      if (formModel) {
        const { validations: notifyValidations = [] } = config;
        if (notifyValidations.length && !this.notifyValidations) {
          this.notifyValidations = form.overrideBaseValidations(notifyValidations, formModel.validations);

          this.notifyValidations = this.notifyValidations.map(validation => {
            const validationFields = merge(formModel.validationsFields, validation);
            validation.validText = format(content.t(validation.validText), validationFields);
            validation.invalidText = format(content.t(validation.invalidText), validationFields);
            return validation;
          });
        }
        if (this.notifyValidations) {
          const validation = find(propEq('type', formModel.validation.type), this.notifyValidations);
          return formModel.validation.valid ? validation.validText : validation.invalidText;
        } else {
          return formModel.validation.valid ? formModel.validation.validText : formModel.validation.invalidText;
        }
      }
    };

    render = () => {
      if (this.props.config.formModel) {
        const { theme, config } = this.props;
        const { form, formModel } = config;
        if (formModel.visited) {
          return (
            <RichText
              ucFirst={true}
              innerStyle={[form.getValidClass(formModel, config.css, theme), theme.computedInnerStyle]}
              text={this.getValidationText()}
            />
          );
        }
      }
      return null;
    };
  }
);
